import { createContext, useContext } from 'react';
const ModalLayoutContext = createContext(null);
export const ModalLayoutProvider = ModalLayoutContext.Provider;
export function useModalLayout() {
    const ctx = useContext(ModalLayoutContext);
    if (!ctx) {
        throw new Error('Modal compound components must be rendered inside <Modal>.');
    }
    return ctx;
}
//# sourceMappingURL=ModalLayoutContext.js.map